import { Region } from "feiertagejs";

export type Area = {
  from: string;
  till: string;
  region: Region;
};

export const areas: Area[] = [
  { from: "01001", till: "01936", region: "SN" }, // Sachsen
  { from: "01001", till: "01936", region: "SN" }, // Sachsen
  { from: "01941", till: "01998", region: "BB" }, // Brandenburg
  { from: "02601", till: "02999", region: "SN" }, // Sachsen
  { from: "03001", till: "03253", region: "BB" }, // Brandenburg
  { from: "04001", till: "04579", region: "SN" }, // Sachsen
  { from: "04581", till: "04639", region: "TH" }, // Thüringen
  { from: "04641", till: "04889", region: "SN" }, // Sachsen
  { from: "04891", till: "04938", region: "BB" }, // Brandenburg
  { from: "06001", till: "06548", region: "ST" }, // Sachsen-Anhalt
  { from: "06551", till: "06578", region: "TH" }, // Thüringen
  { from: "06601", till: "06928", region: "ST" }, // Sachsen-Anhalt
  { from: "07301", till: "07919", region: "TH" }, // Thüringen
  { from: "07919", till: "07919", region: "SN" }, // Sachsen
  { from: "07919", till: "07919", region: "TH" }, // Thüringen
  { from: "07919", till: "07919", region: "SN" }, // Sachsen
  { from: "07920", till: "07950", region: "TH" }, // Thüringen
  { from: "07951", till: "07951", region: "SN" }, // Sachsen
  { from: "07952", till: "07952", region: "TH" }, // Thüringen
  { from: "07952", till: "07952", region: "SN" }, // Sachsen
  { from: "07953", till: "07980", region: "TH" }, // Thüringen
  { from: "07982", till: "07982", region: "SN" }, // Sachsen
  { from: "07985", till: "07985", region: "TH" }, // Thüringen
  { from: "07985", till: "07985", region: "SN" }, // Sachsen
  { from: "07985", till: "07989", region: "TH" }, // Thüringen
  { from: "08001", till: "09669", region: "SN" }, // Sachsen
  { from: "10001", till: "14330", region: "BE" }, // Berlin
  { from: "14401", till: "14715", region: "BB" }, // Brandenburg
  { from: "14715", till: "14715", region: "ST" }, // Sachsen-Anhalt
  { from: "14723", till: "16949", region: "BB" }, // Brandenburg
  { from: "17001", till: "17256", region: "MV" }, // Mecklenburg-Vorpommern
  { from: "17258", till: "17258", region: "BB" }, // Brandenburg
  { from: "17258", till: "17259", region: "MV" }, // Mecklenburg-Vorpommern
  { from: "17261", till: "17291", region: "BB" }, // Brandenburg
  { from: "17301", till: "17309", region: "MV" }, // Mecklenburg-Vorpommern
  { from: "17309", till: "17309", region: "BB" }, // Brandenburg
  { from: "17309", till: "17321", region: "MV" }, // Mecklenburg-Vorpommern
  { from: "17321", till: "17321", region: "BB" }, // Brandenburg
  { from: "17321", till: "17322", region: "MV" }, // Mecklenburg-Vorpommern
  { from: "17326", till: "17326", region: "BB" }, // Brandenburg
  { from: "17328", till: "17331", region: "MV" }, // Mecklenburg-Vorpommern
  { from: "17335", till: "17335", region: "BB" }, // Brandenburg
  { from: "17335", till: "17335", region: "MV" }, // Mecklenburg-Vorpommern
  { from: "17337", till: "17337", region: "BB" }, // Brandenburg
  { from: "17337", till: "19260", region: "MV" }, // Mecklenburg-Vorpommern
  { from: "19271", till: "19273", region: "NI" }, // Niedersachsen
  { from: "19273", till: "19273", region: "MV" }, // Mecklenburg-Vorpommern
  { from: "19273", till: "19306", region: "MV" }, // Mecklenburg-Vorpommern
  { from: "19307", till: "19357", region: "BB" }, // Brandenburg
  { from: "19357", till: "19417", region: "MV" }, // Mecklenburg-Vorpommern
  { from: "20001", till: "21037", region: "HH" }, // Hamburg
  { from: "21039", till: "21039", region: "SH" }, // Schleswig-Holstein
  { from: "21039", till: "21170", region: "HH" }, // Hamburg
  { from: "21202", till: "21449", region: "NI" }, // Niedersachsen
  { from: "21451", till: "21521", region: "SH" }, // Schleswig-Holstein
  { from: "21522", till: "21522", region: "NI" }, // Niedersachsen
  { from: "21524", till: "21529", region: "SH" }, // Schleswig-Holstein
  { from: "21601", till: "21789", region: "NI" }, // Niedersachsen
  { from: "22001", till: "22113", region: "HH" }, // Hamburg
  { from: "22113", till: "22113", region: "SH" }, // Schleswig-Holstein
  { from: "22115", till: "22143", region: "HH" }, // Hamburg
  { from: "22145", till: "22145", region: "SH" }, // Schleswig-Holstein
  { from: "22145", till: "22145", region: "HH" }, // Hamburg
  { from: "22145", till: "22145", region: "SH" }, // Schleswig-Holstein
  { from: "22147", till: "22786", region: "HH" }, // Hamburg
  { from: "22801", till: "23919", region: "SH" }, // Schleswig-Holstein
  { from: "23921", till: "23999", region: "MV" }, // Mecklenburg-Vorpommern
  { from: "24001", till: "25999", region: "SH" }, // Schleswig-Holstein
  { from: "26001", till: "27478", region: "NI" }, // Niedersachsen
  { from: "27483", till: "27498", region: "SH" }, // Schleswig-Holstein
  { from: "27499", till: "27499", region: "HH" }, // Hamburg
  { from: "27501", till: "27580", region: "HB" }, // Bremen
  { from: "27607", till: "27809", region: "NI" }, // Niedersachsen
  { from: "28001", till: "28779", region: "HB" }, // Bremen
  { from: "28784", till: "29399", region: "NI" }, // Niedersachsen
  { from: "29401", till: "29416", region: "ST" }, // Sachsen-Anhalt
  { from: "29431", till: "31868", region: "NI" }, // Niedersachsen
  { from: "32001", till: "33829", region: "NW" }, // Nordrhein-Westfalen
  { from: "34001", till: "34329", region: "HE" }, // Hessen
  { from: "34331", till: "34353", region: "NI" }, // Niedersachsen
  { from: "34355", till: "34355", region: "HE" }, // Hessen
  { from: "34355", till: "34355", region: "NI" }, // Niedersachsen
  { from: "34356", till: "34399", region: "HE" }, // Hessen
  { from: "34401", till: "34439", region: "NW" }, // Nordrhein-Westfalen
  { from: "34441", till: "36399", region: "HE" }, // Hessen
  { from: "36401", till: "36469", region: "TH" }, // Thüringen
  { from: "37001", till: "37194", region: "NI" }, // Niedersachsen
  { from: "37194", till: "37195", region: "HE" }, // Hessen
  { from: "37197", till: "37199", region: "NI" }, // Niedersachsen
  { from: "37201", till: "37299", region: "HE" }, // Hessen
  { from: "37301", till: "37359", region: "TH" }, // Thüringen
  { from: "37401", till: "37649", region: "NI" }, // Niedersachsen
  { from: "37651", till: "37688", region: "NW" }, // Nordrhein-Westfalen
  { from: "37689", till: "37691", region: "NI" }, // Niedersachsen
  { from: "37692", till: "37696", region: "NW" }, // Nordrhein-Westfalen
  { from: "37697", till: "38479", region: "NI" }, // Niedersachsen
  { from: "38481", till: "38489", region: "ST" }, // Sachsen-Anhalt
  { from: "38501", till: "38729", region: "NI" }, // Niedersachsen
  { from: "38801", till: "39649", region: "ST" }, // Sachsen-Anhalt
  { from: "40001", till: "48432", region: "NW" }, // Nordrhein-Westfalen
  { from: "48442", till: "48465", region: "NI" }, // Niedersachsen
  { from: "48466", till: "48477", region: "NW" }, // Nordrhein-Westfalen
  { from: "48478", till: "48480", region: "NI" }, // Niedersachsen
  { from: "48481", till: "48485", region: "NW" }, // Nordrhein-Westfalen
  { from: "48486", till: "48488", region: "NI" }, // Niedersachsen
  { from: "48489", till: "48496", region: "NW" }, // Nordrhein-Westfalen
  { from: "48497", till: "48531", region: "NI" }, // Niedersachsen
  { from: "48541", till: "48739", region: "NW" }, // Nordrhein-Westfalen
  { from: "49001", till: "49459", region: "NI" }, // Niedersachsen
  { from: "49461", till: "49549", region: "NW" }, // Nordrhein-Westfalen
  { from: "49551", till: "49849", region: "NI" }, // Niedersachsen
  { from: "50101", till: "51597", region: "NW" }, // Nordrhein-Westfalen
  { from: "51598", till: "51598", region: "RP" }, // Rheinland-Pfalz
  { from: "51601", till: "53359", region: "NW" }, // Nordrhein-Westfalen
  { from: "53401", till: "53579", region: "RP" }, // Rheinland-Pfalz
  { from: "53581", till: "53604", region: "NW" }, // Nordrhein-Westfalen
  { from: "53614", till: "53619", region: "RP" }, // Rheinland-Pfalz
  { from: "53621", till: "53949", region: "NW" }, // Nordrhein-Westfalen
  { from: "54181", till: "55239", region: "RP" }, // Rheinland-Pfalz
  { from: "55240", till: "55252", region: "HE" }, // Hessen
  { from: "55253", till: "56869", region: "RP" }, // Rheinland-Pfalz
  { from: "57001", till: "57489", region: "NW" }, // Nordrhein-Westfalen
  { from: "57501", till: "57648", region: "RP" }, // Rheinland-Pfalz
  { from: "58001", till: "59966", region: "NW" }, // Nordrhein-Westfalen
  { from: "59969", till: "59969", region: "HE" }, // Hessen
  { from: "59969", till: "59969", region: "NW" }, // Nordrhein-Westfalen
  { from: "60001", till: "63699", region: "HE" }, // Hessen
  { from: "63701", till: "63774", region: "BY" }, // Bayern
  { from: "63776", till: "63776", region: "HE" }, // Hessen
  { from: "63776", till: "63928", region: "BY" }, // Bayern
  { from: "63928", till: "63928", region: "BW" }, // Baden-Württemberg
  { from: "63930", till: "63939", region: "BY" }, // Bayern
  { from: "64201", till: "64753", region: "HE" }, // Hessen
  { from: "64754", till: "64754", region: "BW" }, // Baden-Württemberg
  { from: "64754", till: "65326", region: "HE" }, // Hessen
  { from: "65326", till: "65326", region: "RP" }, // Rheinland-Pfalz
  { from: "65327", till: "65391", region: "HE" }, // Hessen
  { from: "65391", till: "65391", region: "RP" }, // Rheinland-Pfalz
  { from: "65392", till: "65556", region: "HE" }, // Hessen
  { from: "65558", till: "65582", region: "RP" }, // Rheinland-Pfalz
  { from: "65583", till: "65620", region: "HE" }, // Hessen
  { from: "65621", till: "65626", region: "RP" }, // Rheinland-Pfalz
  { from: "65627", till: "65627", region: "HE" }, // Hessen
  { from: "65629", till: "65629", region: "RP" }, // Rheinland-Pfalz
  { from: "65701", till: "65936", region: "HE" }, // Hessen
  { from: "66001", till: "66459", region: "SL" }, // Saarland
  { from: "66461", till: "66509", region: "RP" }, // Rheinland-Pfalz
  { from: "66511", till: "66839", region: "SL" }, // Saarland
  { from: "66841", till: "67829", region: "RP" }, // Rheinland-Pfalz
  { from: "68001", till: "68312", region: "BW" }, // Baden-Württemberg
  { from: "68501", till: "68519", region: "HE" }, // Hessen
  { from: "68520", till: "68549", region: "BW" }, // Baden-Württemberg
  { from: "68601", till: "68649", region: "HE" }, // Hessen
  { from: "68701", till: "69234", region: "BW" }, // Baden-Württemberg
  { from: "69235", till: "69239", region: "HE" }, // Hessen
  { from: "69240", till: "69429", region: "BW" }, // Baden-Württemberg
  { from: "69430", till: "69431", region: "HE" }, // Hessen
  { from: "69434", till: "69434", region: "BW" }, // Baden-Württemberg
  { from: "69434", till: "69434", region: "HE" }, // Hessen
  { from: "69435", till: "69469", region: "BW" }, // Baden-Württemberg
  { from: "69479", till: "69488", region: "HE" }, // Hessen
  { from: "69489", till: "69502", region: "BW" }, // Baden-Württemberg
  { from: "69503", till: "69509", region: "HE" }, // Hessen
  { from: "69510", till: "69514", region: "BW" }, // Baden-Württemberg
  { from: "69515", till: "69518", region: "HE" }, // Hessen
  { from: "70001", till: "74592", region: "BW" }, // Baden-Württemberg
  { from: "74594", till: "74594", region: "BY" }, // Bayern
  { from: "74594", till: "76709", region: "BW" }, // Baden-Württemberg
  { from: "76711", till: "76891", region: "RP" }, // Rheinland-Pfalz
  { from: "77601", till: "79879", region: "BW" }, // Baden-Württemberg
  { from: "80001", till: "87491", region: "BY" }, // Bayern
  { from: "87491", till: "87491", region: "BUND" }, // Außerhalb der BRD
  { from: "87493", till: "87561", region: "BY" }, // Bayern
  { from: "87567", till: "87569", region: "BUND" }, // Außerhalb der BRD
  { from: "87571", till: "87789", region: "BY" }, // Bayern
  { from: "88001", till: "88099", region: "BW" }, // Baden-Württemberg
  { from: "88101", till: "88146", region: "BY" }, // Bayern
  { from: "88147", till: "88147", region: "BW" }, // Baden-Württemberg
  { from: "88147", till: "88179", region: "BY" }, // Bayern
  { from: "88181", till: "89079", region: "BW" }, // Baden-Württemberg
  { from: "89081", till: "89081", region: "BY" }, // Bayern
  { from: "89081", till: "89085", region: "BW" }, // Baden-Württemberg
  { from: "89087", till: "89087", region: "BY" }, // Bayern
  { from: "89090", till: "89198", region: "BW" }, // Baden-Württemberg
  { from: "89201", till: "89449", region: "BY" }, // Bayern
  { from: "89501", till: "89619", region: "BW" }, // Baden-Württemberg
  { from: "90001", till: "96489", region: "BY" }, // Bayern
  { from: "96501", till: "96529", region: "TH" }, // Thüringen
  { from: "97001", till: "97859", region: "BY" }, // Bayern
  { from: "97861", till: "97877", region: "BW" }, // Baden-Württemberg
  { from: "97888", till: "97892", region: "BY" }, // Bayern
  { from: "97893", till: "97896", region: "BW" }, // Baden-Württemberg
  { from: "97896", till: "97896", region: "BY" }, // Bayern
  { from: "97897", till: "97900", region: "BW" }, // Baden-Württemberg
  { from: "97901", till: "97909", region: "BY" }, // Bayern
  { from: "97911", till: "97999", region: "BW" }, // Baden-Württemberg
  { from: "98501", till: "99998", region: "TH" }, // Thüringen
];
